import { useTheme } from 'foundations-theming-specialty/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NeutralIcon = ({
  title
}) => {
  const trellisTheme = useTheme();
  return /*#__PURE__*/_jsxs("svg", {
    viewBox: "0 0 54 54",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    children: [title ? /*#__PURE__*/_jsx("title", {
      children: title
    }) : null, /*#__PURE__*/_jsx("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/_jsx("g", {
        transform: "translate(-958.000000, -762.000000)",
        fillRule: "nonzero",
        children: /*#__PURE__*/_jsx("g", {
          transform: "translate(761.000000, 320.000000)",
          children: /*#__PURE__*/_jsxs("g", {
            transform: "translate(198.000000, 443.000000)",
            children: [/*#__PURE__*/_jsx("path", {
              d: "M26,0 C11.6405965,0 0,11.6405965 0,26 C0,40.3594035 11.6405965,52 26,52 C40.3594035,52 52,40.3594035 52,26 C51.9787869,11.6493924 40.3506076,0.0212130541 26,0 Z",
              stroke: trellisTheme.color['do-not-use-obsidian'],
              strokeWidth: "2",
              fill: trellisTheme.color['do-not-use-sorbet-medium']
            }), /*#__PURE__*/_jsx("path", {
              d: "M35.0518519,18.1422222 C36.5085151,18.1422222 37.821746,19.019695 38.3791869,20.3654764 C38.9366278,21.7112578 38.6285003,23.2603192 37.5984838,24.2903357 C36.5684673,25.3203522 35.019406,25.6284796 33.6736246,25.0710387 C32.3278432,24.5135978 31.4503704,23.200367 31.4503704,21.7437037 C31.4503704,19.7546604 33.0628086,18.1422222 35.0518519,18.1422222 L35.0518519,18.1422222 Z",
              fill: trellisTheme.color['do-not-use-obsidian']
            }), /*#__PURE__*/_jsx("path", {
              d: "M16.9481481,18.1422222 C18.4048114,18.1422222 19.7180423,19.019695 20.2754832,20.3654764 C20.8329241,21.7112578 20.5247966,23.2603192 19.4947801,24.2903357 C18.4647636,25.3203522 16.9157022,25.6284796 15.5699209,25.0710387 C14.2241395,24.5135978 13.3466667,23.200367 13.3466667,21.7437037 C13.3466667,19.7546604 14.9591048,18.1422222 16.9481481,18.1422222 Z",
              fill: trellisTheme.color['do-not-use-obsidian']
            }), /*#__PURE__*/_jsx("rect", {
              fill: trellisTheme.color['do-not-use-obsidian'],
              x: "14.4444444",
              y: "34.4162963",
              width: "23.1111111",
              height: "3.85185185",
              rx: "1.92592593"
            })]
          })
        })
      })
    })]
  });
};
export default NeutralIcon;